// @copyright  2006-2023 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: 'assignees',
        component: () =>
            import('@/pages/[organisation]/projects/project-checklist-task-users/project-checklist-task-users.vue'),
        name: 'project-management.project-checklist-task-users.search-project-checklist-task-users',
        meta: {
            loginRequired: true,
            permission: 'access.project.project-checklist-task-users.view-project-checklist-task-users',
        },
    },
];
